import styled, { css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	background: white;
	border: 2px dashed;
	border-color: ${({ shaded }) => (!shaded ? colors.amber : colors.grey3)};
	box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
	padding: 16px 32px;
	margin-bottom: 24px;
	display: flex;

	&:hover {
		box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
	}

	${({ shaded }) =>
		shaded &&
		css`
			${Title} {
				color: ${colors.grey3};
			}
		`};
`;

export const Title = styled.div`
	font-weight: 500;
	font-size: 23px;
	line-height: 31px;
	letter-spacing: 0.3px;
	color: ${colors.grey7};
`;

export const TitleWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
`;

export const ActionsWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export const Divider = styled.div`
	width: 1px;
	height: 24px;
	margin: 0 16px;
	background-color: ${colors.grey3};
`;
